import BooksSection from "@/components/BooksSection";
import { motion } from "framer-motion";
import { useTrackView } from "@/lib/trackInterest";

export default function BooksPage() {
  useTrackView("books", "Books");
  return (
    <main className="pt-32 md:pt-40">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
          className="grid grid-cols-12 gap-y-8"
        >
          <div className="col-span-12 md:col-span-8">
            <div className="section-tag mb-4">§ Amazon · Paperback & Kindle</div>
            <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.88] tracking-tighter">
              Read the <span className="italic text-[#B45309]">doctrine</span>.
            </h1>
          </div>
          <div className="col-span-12 md:col-span-4 flex items-end">
            <p className="text-[#78716C] text-lg leading-relaxed">
              Available everywhere Amazon ships. Kindle editions sync across devices — perfect for a pre-shift chapter.
            </p>
          </div>
        </motion.div>
      </section>
      <BooksSection heading={false} />
    </main>
  );
}
